
import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { AuthService } from '../authentication/auth.service';
import {Observable} from 'rxjs/Rx';
import { environment } from '../../../environments/environment';
import 'rxjs/add/operator/do';
import { Router } from '@angular/router'
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import { tap, map, filter, retry, catchError } from 'rxjs/operators';
import { observable } from 'rxjs';``
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from "ngx-spinner";


@Injectable()

export class AuthInterceptor implements HttpInterceptor {
    cookieValue : string;
    baseUrl = environment.baseUrl;



    constructor(private authService: AuthService,
        private router : Router,
        private toastr: ToastrService,
        public spinner: NgxSpinnerService,
    ) {}

   

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
      this.spinner.show();
        this.cookieValue = localStorage.getItem('access_token')
        console.log('....inter ceptor....', this.cookieValue )
        if(request.url == this.baseUrl+ 'login'){
            if(this.cookieValue == null) {
                console.log('first header')

                request = request.clone({
                    setHeaders: {
                      "Content-Type": "application/x-www-form-urlencoded",
                      "Authorization": "Basic VU5TVUI6VU5TVUIxMjM=" ,
                      
                    }
                  });
            }
            else if(this.cookieValue != null) {
              localStorage.removeItem('access_token')
              console.log('....inter ceptor else if....', this.cookieValue )
            }
            
        }
        else {
            // if(this.cookieValue.length != 0) {
                console.log('second header')
                request = request.clone({
                    setHeaders: {
                      "Content-Type": "application/json",
                      "Authorization": `Bearer ${this.authService.getToken()}` ,
                      
                    }
                  });
            // }
            
        }
        return next.handle(request).do((event: HttpEvent<any>) => {
          this.spinner.hide();

            if (event instanceof HttpResponse) {
              // do stuff with response if you want
            }
          }, (async(err: any) => {
            this.spinner.hide();
                console.log('erorrrrrrrrrrrrrrrrrrrrrrrr', err)
              if (err.error.status === 401) {
                this.router.navigate([''])
                this.authService.logout()
           
                
              return next.handle(request).toPromise().then(data => {
                console.log("requeried data:", data);
                return data; 
              });
              }
              if (err.error.status === 500) {
                this.toastr.error('Wrong Credentials!');

              }
            // }
          }));
  }

 
    
}

